<template>
  <van-popup
    class="advertisement_-conter"
    v-model="$store.state.CancelIsSigned_days"
    z-index="2300"
  >
    <!-- CancelDisplay -->
    <div class="advertisement_list _border" style="overflow: hidden">
      <div class="ZAJ3tO484KoZnr7Y6n_l">{{ $t('components._CheckInDi') }}</div>
      <div class="xmHlf3AdKNfopQZxGTk7">
        <div class="wPL4o40ajO3bGEmyjpNf">
          <div class="G9JHenpYWEhrwkyqb33R" style="margin-bottom: 0.2rem">
            <div class="G9JHenpYWEhrwkyqb33R">
              <p>{{ $t('components._Check_insconsecutivos') }}:</p>
              <span class="notranslate">{{ formDate.signed_days }}</span>
            </div>
            <div class="G9JHenpYWEhrwkyqb33R">
              <p>{{ $t('components._Resgatado') }} :</p>
              <span
                class="notranslate daV6P29LBSJRZ5JRmzrV"
                style="color: var(--theme-label-secondary-color-finance)"
                >{{ formDate.get_money }}</span
              >
              <svg-icon
                className="ZaAWGnvFuhPwlBk40od_"
                icon-class="comm_icon_sx--svgSprite:all"
              />
            </div>
          </div>
          <div class="G9JHenpYWEhrwkyqb33R">
            <div class="G9JHenpYWEhrwkyqb33R">
              <p>{{ $t('components._Depósitoobrigatrio') }} :</p>
              <span class="notranslate daV6P29LBSJRZ5JRmzrV"
                ><span style="color: var(--theme-secondary-color-error)">{{
                  formDate.today_recharge_str
                }}</span
                >/{{ formDate.need_recharge }}</span
              >
            </div>
            <div class="G9JHenpYWEhrwkyqb33R">
              <p>{{ $t('components._Apostaobrigatri') }} :</p>
              <span class="notranslate daV6P29LBSJRZ5JRmzrV">
                <span style="color: var(--theme-secondary-color-error)">{{
                  formDate.today_bet_str
                }}</span
                >/ {{ formDate.need_bet }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div style="overflow-x: hidden; height: calc(100vh - 7rem)">
        <div class="xmHlf3AdKNfopQZxGTk7">
          <div class="wPL4o40ajO3bGEmyjpNf" style="padding: 0">
            <div class="_list_1rbyt_24">
              <div
                class="_item_zocom_17 _sign-item0_zocom_39"
                v-if="formDate.list"
                v-for="(item, index) in formDate.list"
              >
                <!---->
                <div class="_reward-pattern_zocom_54">
                  <img
                    class="lobby-image lobby-image picture"
                    src="https://o22y77.77y22.com/siteadmin/active/qd_style4_img_qdjb2.png"
                    alt="."
                  />
                </div>
                <div class="_reward-description_zocom_113">
                  <div class="text-wrap yellow">{{ item.bonus }}</div>
                  <div class="divider"></div>
                </div>
                <div
                  class="_caption_zocom_135"
                  v-if="formDate.now_day < item.day"
                >
                  Dia {{ item.day }}
                </div>
                <div class="_caption_zocom_135" v-else>
                  <button
                    @click="ReceberTudo"
                    v-if="formDate.now_day == item.day"
                    class="van-button van-button--primary ui-button--success ui-button--normal _sign-btn_zocom_145"
                  >
                    <span class="ui-button__text">{{
                      $t('components._Entrar')
                    }}</span
                    ><!---->
                  </button>
                  <button
                    v-else
                    class="van-button van-button--primaryui-button--success ui-button--success ui-button--normal _sign-btn_zocom_145"
                  >
                    <span class="ui-button__text">{{
                      $t('components._Entrar')
                    }}</span
                    ><!---->
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="xmHlf3AdKNfopQZxGTk7">
          <div class="wPL4o40ajO3bGEmyjpNf" v-html="formDate.desc"></div>
        </div>
      </div>
    </div>

    <MyToast
      :isShow="isMyToast"
      @cancel="isMyToast = false"
      @confirm="openConfirm"
      :model="{
        title: $t('components._Falhanocheckin'),
        message: message,
        buttomValue: $t('components._Irparadepsito'),
        type: 'fail' //success fail
      }"
    ></MyToast>

    <div
      class=""
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.4rem;
      "
    >
      <img
        style="width: 0.5984rem; height: 0.5984rem; cursor: pointer"
        @click="cunSltenmefals"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
      />
    </div>
  </van-popup>
</template>

<script>
import { dailySignIn, doDailySign } from '@/apis/modules/detail.js';
import MyToast from '@/components/MyToast/index.vue';
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['vuex_token_head'])
  },
  components: {
    MyToast
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    model: {
      type: [Object, Array],
      required: {}
    }
  },
  data() {
    return {
      isMyToast: false,
      codeValue: '',
      message: false,
      CancelDisplay: false,
      mesnComenste: false,
      inputFocus: false,
      formDate: {}
    };
  },
  created() {
    this.getNotification();
    setTimeout(() => {
      this.isShow = true;
    }, 1500);
  },
  methods: {
    getNotification() {
      dailySignIn({}).then(({ code, data, msg }) => {
        //404
        this.formDate = data;
        //
      });
    },
    openConfirm() {
      this.isMyToast = false;
      this.mesnComenste = false;
      setTimeout(() => {
        this.$store.commit('isDeposit', true);
      }, 300);
    },
    checkLogin() {
      if (!this.vuex_token_head) {
        let rememberPassword = window.localStorage.getItem('rememberPassword');
        if (rememberPassword && rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    ReceberTudo() {
      if (!this.checkLogin()) return;
      doDailySign({
        activity: 'lossSubsidy'
      }).then(({ code, data, msg }) => {
        //404
        if (code == 1) {
          this.isMyToast = true;
          this.message = msg;
          return false;
        } else if (code == 0) {
          Toast.success(msg);
          this.getNotification();
        } else {
          Toast.loading(msg);
        }
      });
    },
    cunSltenmefals() {
      this.$store.commit('publicFun', ['CancelIsSigned_days', false]);
      // CancelIsSigned_days
    },
    openUrl(e) {
      if (e.jump_url && e.jump_url != '#') {
        this.$router.push({
          name: e.jump_url
        });
      }
    }
  }
};
</script>
<style>
.login-body {
  font-weight: 400;
}

.van-popup.advertisement_-conter {
  background-color: transparent;
}

.ZaAWGnvFuhPwlBk40od_.svg-icon {
  width: 0.24rem !important;
  height: 0.24rem !important;
  color: var(--theme-label-secondary-color-finance);
  margin-left: 0.15rem;
}
</style>
<style scoped>
.wPL4o40ajO3bGEmyjpNf {
  background-color: var(--theme-bg-color);
  /* border: 0.01rem solid var(--theme-primary-color); */
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.06);
  padding: 0.25rem 0.2rem;
}
.van-button--primaryui-button--success {
  background-color: var(--theme-disabled-bg-color);
  border-color: var(--theme-disabled-bg-color);
  color: var(--theme-disabled-font-color);
}
._sign-item0_zocom_39 ._reward-pattern_zocom_54 {
  margin-top: 0;
}

._sign-item0_zocom_39 ._caption_zocom_135 {
  height: 0.55rem !important;
}

._sign-item0_zocom_39 .sign-badge,
._sign-item6_zocom_158 .sign-badge {
  left: auto;
  right: -0.15rem;
}

._list_1rbyt_24 {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  padding: 0.2rem 0 0.05rem 0.2rem;
  background-color: var(--skin__bg_2);
  border-radius: 0.14rem;
}
._item_zocom_17 {
  position: relative;
  z-index: 1;
  width: 1.96rem;
  height: 2.55rem;
  margin-right: 0.21rem;
  margin-bottom: 0.2rem;
  border: 0.01rem solid var(--theme-text-color);
  border-radius: 0.14rem;
  box-sizing: border-box;
  box-shadow: 0 0.01rem 0.09rem rgba(68, 68, 68, 0.1);
}
._item_zocom_17:nth-child(3n) {
  margin-right: 0;
}

._item_zocom_17._sign-item0_zocom_39 {
  margin-right: 0.2rem;
}

._item_zocom_17._sign-item0_zocom_39:nth-child(3n) {
  margin-right: 0;
}

._item_zocom_17 .sign-badge {
  position: absolute;
  top: 0;
  left: 50%;
  transform: none;
  right: auto;
  max-width: inherit !important;
  color: #ff0;
}

._item_zocom_17 ._reward-pattern_zocom_54 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.24rem;
  height: 1.24rem;
  margin: 0.2rem auto 0;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .bg-receive {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 1.24rem;
  transform: translate(-50%, -50%);
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive {
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 0.5rem;
  margin-top: 0.02rem;
  font-weight: 700;
  font-size: 0.22rem;
  line-height: 0.24rem;
  text-align: center;
  transform: scale(0.7) rotate(-18deg);
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive .text {
  position: relative;
  top: 0;
  display: grid;
  line-height: 0;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(zh) {
  font-size: 0.32rem;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(en) {
  font-size: 0.32rem;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(pt) {
  font-size: 0.26rem;
}

._item_zocom_17 ._reward-pattern_zocom_54 .picture {
  display: block;
  width: 100%;
  height: 100%;
}

._item_zocom_17 ._reward-description_zocom_113 {
  margin-bottom: 0.01rem;
  padding: 0.01rem 0.1rem;
}

._item_zocom_17 ._reward-description_zocom_113 .divider {
  border-top: 0.01rem solid var(--theme-text-color);
}

._item_zocom_17 ._reward-description_zocom_113 .text-wrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  width: 100%;
  height: 0.3rem;
  margin-bottom: 0.2rem;
  font-size: 0.22rem;
  line-height: 0.3rem;
  text-align: center;
}

._item_zocom_17 ._reward-description_zocom_113 .yellow {
  color: var(--skin__accent_3);
}

._item_zocom_17 ._caption_zocom_135 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.4rem;
  padding-top: 0;
  color: var(--skin__neutral_2);
  font-size: 0.24rem;
  line-height: 1.29;
}

._item_zocom_17 ._caption_zocom_135 ._sign-btn_zocom_145 {
  width: 1.2rem;
  height: 0.4rem;
  font-size: 0.18rem;
  border-radius: 0.1rem;
  padding: 0 0.05rem;
}

._item_zocom_17
  ._caption_zocom_135
  ._sign-btn_zocom_145
  :not(:lang(zh))
  .ui-button__text {
  word-break: break-word;
}

.advertisement_list {
  height: calc(100vh - 4.3rem);
}

.G9JHenpYWEhrwkyqb33R {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.xmHlf3AdKNfopQZxGTk7 {
  margin: 0.2rem;
  text-align: left;
  color: var(--theme-disabled-font-color);
  font-size: 0.24rem;
}

html .ant-btn.ant-btn-primary {
  width: 5rem;
  font-size: 0.24rem;
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  margin-top: 0;
  display: flex;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  justify-content: center;
}

html .ant-btn.ant-btn-primary {
  color: var(--theme-primary-font-color);
  text-shadow: none;
  height: 0.7rem;
  border-radius: 0.14rem;
}

.ZAJ3tO484KoZnr7Y6n_l {
  color: var(--theme-text-color-darken);
  font-size: 0.3rem;
  padding: 0.2rem 0.3rem;
  font-weight: 400;
}

.RlMZ1IA0k4zaYVTGjIiN {
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
  margin-bottom: 0.4rem;
  margin-top: 0.3rem;
  min-height: 0.7rem;
}

.advertisement_list {
  width: 7.1rem;
  box-sizing: border-box;
  text-align: center;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.2rem;
}

.advertisement_list .title {
  /* color: var(--theme-label-secondary-color-finance); */
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
}

._common-tabs-content {
  max-height: 5.4rem;
  width: 100%;
}

.consliTst {
  display: flex;
  align-items: center;
  border-radius: 0.1rem;
  height: 0.8rem !important;
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
  max-width: 2.05rem;
  padding: 0.15rem;
  text-align: revert !important;
}

.consliTst svg {
  width: 0.38rem;
  height: 0.38rem;
  color: var(--theme-primary-color);
  margin-right: 0.08rem;
}

.consliTst span {
  font-size: 0.22rem;
  display: inline-block;
  line-height: 0.28rem;
  flex: 1;
  color: var(--theme-primary-color);
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  white-space: break-spaces !important;
}
</style>
